import React from 'react'
import { UserSessionsFilters } from '../../../API/UserSessions/models'; 

export const DateSelector = ({ filters, setFilters }: { filters: UserSessionsFilters, setFilters: (filters: UserSessionsFilters) => void }) => {
    return (
        <div className="d-flex gap-2">
            <div className="d-flex flex-column align-items-start">
                <label htmlFor="start" className="text-white mb-1"><small>Fecha inicio</small></label>
                <input
                    value={filters.startDate}
                    type="date"
                    id="start"
                    name="start"
                    className="form-control text-white"
                    onChange={(e) => setFilters({ ...filters, startDate: e.target.value })}
                />
            </div>

            <div className="d-flex flex-column align-items-start">
                <label htmlFor="end" className="text-white mb-1"><small>Fecha fin</small></label>
                <input
                    value={filters.endDate}
                    type="date"
                    id="end"
                    name="end"
                    className="form-control text-white"
                    onChange={(e) => setFilters({ ...filters, endDate: e.target.value })}
                />
            </div>
        </div>
    )
}
